const ja = {
  // Navigation
  nav: {
    about: '会社概要',
    business: '事業内容',
    stats: '実績',
    works: '制作実績',
    news: 'ニュース',
    contact: 'お問い合わせ',
    values: '企業理念',
    recruitment: '採用情報',
    security: '情報セキュリティ',
    topPage: 'トップページ',
  },
  
  // Services
  services: {
    title: 'サービス',
  },
  
  // Footer
  footer: {
    copyright: '© 2026 TradFit株式会社',
    privacy: 'プライバシーポリシー',
  },
  
  // Carousel
  carousel: {
    slide1: {
      title: '生成AIで未来を創造する',
      description: '最先端の生成AI技術で、ビジネスの可能性を無限に広げます。データから価値を生み出し、革新的なソリューションを提供します。'
    },
    slide2: {
      title: '生成AIが導く次世代のビジネス',
      description: '機械学習とディープラーニングを活用し、企業の成長を加速させます。インテリジェントな意思決定をサポートします。'
    },
    slide3: {
      title: '生成AIでイノベーションを実現する',
      description: '生成AI技術により、創造性と効率性を両立。お客様のビジネスに最適なAIソリューションをカスタマイズします。'
    },
    learnMore: '詳しく見る'
  },
  // Hero
  hero: {
    title: 'TradFitのミッションは、生成AIの力でお客様のビジネスプロセスを再定義し、',
    subtitle: 'お客様の新たな価値を創出することで三方よしを実現する事です。',
    whoAreWe: '[私たちについて]',
    tagline: '業種・業態・企業規模問わず生成AIの力でお客様の成長を支援しています',
  },
  
  // Footer tagline
  footerTagline: '生成AI・音声AIのリーディングカンパニー\n東京丸の内を拠点に、日本の課題解決に挑んでいます',

  // Home page
  home: {
    heroTitle: '生成AIで未来を',
    heroTitleHighlight: '創造する',
    heroSubtitle: '最先端の技術で、ビジネスの可能性を無限に広げます。データから価値を生み出し、革新的なソリューションを提供します',
    heroCta1: '事業内容を見る',
    heroCta2: 'お問い合わせ',
    missionText: 'TradFitのミッションは、生成AIの力でお客様のビジネス\nプロセスを再定義し、お客様の新たな価値を創出することで\n三方よしを実現する事です',
    servicesTag: 'Our Services',
    servicesTitle: 'イノベーションを実現する',
    servicesSubtitle: '最先端のAI技術と深い業界知見を組み合わせ、お客様のビジネス課題に最適なソリューションを提供します',
    techTag: 'Technology',
    techTitle: '弊社の技術領域',
    techSubtitle: '最先端のテクノロジーを活用し、お客様のビジネス課題を多角的に解決します',
    aboutTag: 'About Us',
    aboutTitle: '日本のビジネスに革新を',
    aboutSubtitle: '東京都千代田区丸の内に本社を置くTradFit株式会社は、2017年の設立以来、生成AI・音声AIのリーディングカンパニーとして、DX推進を支援しています',
    aboutText1: '生成AI・音声AIの技術と綿密な知財戦略を核に、企業のデジタルトランスフォーメーションを総合的に支援しています',
    aboutText2: '幅広いサービスラインアップで、業種・業態・規模を問わず、お客様の課題解決に取り組んでいます',
    aboutBtn: '会社概要を見る',
    newsTag: 'News',
    newsTitle: '最新情報',
    newsViewAll: 'すべて見る',
    servicesViewAll: '事業内容を見る',
    ctaTitle: '生成AIの力で、ビジネスを次のステージへ',
    ctaSubtitle: 'お気軽にご相談ください',
    ctaBtn: 'お問い合わせ',
    service1Title: '生成AIコンサルティング・開発支援',
    service1Desc: '最先端の生成AI技術を活用し、企業の業務効率化とイノベーション創出を支援。戦略立案から実装まで一貫サポート',
    service2Title: 'Hospitalia 音声AIソリューション',
    service2Desc: '日本初のAlexa SP認定を受けた音声AIプラットフォーム。観光・ヘルスケア・自治体向けに業界特化型ソリューションを提供',
    service3Title: 'サイバーセキュリティー対策サービス',
    service3Desc: '20年以上インシデントゼロの圧倒的実績。ADサーバーから全端末まで、お客様のニーズに合わせた柔軟な導入を実現',
    service4Title: '生成AIマーケティング支援サービス',
    service4Desc: '生成AIでコンテンツ制作を革新。データドリブンなターゲティングと最適化でマーケティングROIを最大化し、ブランド価値を向上',
    tech1Title: '生成AI',
    tech1Desc: 'LLM・画像・音声生成を活用したコンテンツ・業務自動化ソリューション',
    tech2Title: '人工知能',
    tech2Desc: '機械学習・ディープラーニング・自然言語処理（NLP）・その他AI技術全般',
    tech3Title: 'ロボティクス',
    tech3Desc: '自律走行ロボット・サービスロボットとのAIシステム連携・導入支援',
    tech4Title: 'フィジカルAI',
    tech4Desc: '現実空間で自律的に判断・行動するAIシステムの設計・構築',
    tech5Title: 'IoT',
    tech5Desc: 'スマートデバイス・センサー・クラウド連携によるリアルタイムデータ活用基盤',
    tech6Title: '生体認証',
    tech6Desc: '声紋・顔認証・虹彩・指紋・静脈認証によるセキュアな本人確認',
    tech7Title: 'ビッグデータ',
    tech7Desc: '大規模データの収集・分析・可視化によるデータドリブン経営支援',
    tech8Title: '知財・特許',
    tech8Desc: 'AI・ソフトウェア・ビジネスモデルに関する知的財産を数多く保有',
    learnMore: '詳しく見る',
    newsItem1: '医療従事者の負担軽減と入院患者の満足度向上を目指した音声アシスト病室の概念実証を実施',
    newsItem2: '元野村証券専務、元野村総合研究所副会長の百瀬裕規氏がTradFit社のエグゼクティブ・アドバイザーに就任',
    newsItem3: 'トラベルボイスに掃載されました。TradFit社、NECネッツエスアイと販売店契約、AI音声サービス「ホスピタリア」のサポート体制を強化',
    newsItem4: 'Amazon Alexa Smart Propertiesの活用により観光・宿泊業界、ヘルスケア業界、自治体の業務効率化と生産性の向上をサポート',
  },

  // News hero subtitle
  newsHeroSubtitle: 'ニュース・プレスリリース・イベント情報',

  // Language
  language: {
    english: 'English',
    japanese: '日本語',
    korean: '한국어',
    chinese: '繁體中文',
  },

  // About Page
  about: {
    title: '会社概要',
    subtitle: 'ABOUT US',
    missionTitle: 'TradFitのミッション',
    missionText1: 'TradFitのミッションは、生成AIの力でお客様のビジネスプロセスを再定義し、お客様の新たな価値を創出することで三方よしを実現する事です',
    missionText2: '生成AIとビジネスを熟知した精鋭メンバーによる、圧倒的なデリバリースピードと、ビジネスを加速する守りと攻めの知財戦略により、国内外における強固な特許ポートフォリオを保持していることが弊社の強みです',
    valuesTitle: 'TradFitのバリュー',
    businessContent: '事業内容（国内外特許取得済・出願中）',
    businessContentText: '① 観光・ヘルスケア・自治体向け音声AIソリューション（Hospitalia）② 生成AIコンサルティング・開発支援サービス③ サイバーセキュリティー対策サービス④ 生成AIマーケティング支援サービス（音声AIデータプラットフォームの構築及び運営含む。国内・国際特許取得済・出願中）',
    businessItems: [
      '生成AIコンサルティング事業',
      '生成AI開発事業',
      '生成AIマーケティング事業',
      'サイバーセキュリティ事業',
      '観光・ヘルスケア・自治体向け音声AIソリューション（Hospitalia）',
    ],
    businessNote: '国内外特許取得済・出願中',
    companyInfo: '会社情報',
    companyName: '会社名',
    companyNameValue: 'TradFit株式会社(トラッドフィット)',
    companyNameEn: 'TradFit Co., Ltd.',
    established: '設立',
    establishedValue: '2017年8月',
    capital: '資本金',
    capitalValue: '100百万円',
    ceo: '代表取締役',
    ceoValue: '戸田良樹',
    headquarters: '本社所在地',
    headquartersPostal: '〒100-0005',
    headquartersAddress1: '東京都千代田区丸の内一丁目6番5号',
    headquartersAddress2: '丸の内北口ビルディング9階',
    contact: 'お問い合わせ',
    shareholders: '株主構成',
    shareholdersText: 'ニッセイ・キャピタル株式会社(日本生命グループ)、GMO VenturePartners株式会社、株式会社パソナグループ、事業創造キャピタル株式会社(NSGグループ)、経営陣等',
    affiliations: '所属団体',
    affiliation1: 'AWS パートナー ソフトウェアパスに国際公式認定',
    affiliation2: 'Google Cloud™ Build パートナーとして国際公式認定',
    affiliation3: '一般社団法人 宿泊施設関連協会 (JARC/Japan Accommodation Consortium)',
    affiliation4: '公益社団法人 日本観光振興協会 (JAPAN TRAVEL AND TOURISM ASSOCIATION)',
    affiliation5: '公益財団法人 東京観光財団 (Tokyo Convention & Visitors Bureau)',
    majorClients: '取引先（一部抜粋）',
    majorClientsText: 'IT業界, 士業業界, 個人事業主, 美容業界, ブライダル業界, 学校法人業界, 不動産業界, 電鉄業界, 宿泊業界・ヘルスケア業界など',
    partners: '提携先（一部抜粋）',
    partnersText: '国内外の中小企業・中堅企業・大手企業など',
    awards: '受賞歴（一部抜粋）',
    award1: '新潟県の革新的なスタートアップ企業として「J-Startup NIIGATA」に認定',
    award2: 'トラベルボイス株式会社による国内外の注目企業セレクト10に選出',
    award3: '経済産業省・特許庁 第3回「IP BASE AWARD」奨励賞 (スタートアップ部門) 受賞',
    award4: 'NIIGATA VENTURE AWARD 2022 最優秀賞 受賞',
    award5: '日本スタートアップ支援協会主催「The JSSA MeetUp＆Award Vol.39」最優秀賞 受賞',
    award6: 'One of the "Top 10 Cognitive Solution Providers 2022" by APAC CIOoutlook',
    award7: 'One of the "10 Ethical Companies of the Year 2022" by The Silicon Review',
    award8: '"Enterprising Companies of the Year" by The Enterprise World',
    award9: 'アジアの注目企業100に3年連続で選出',
    award10: 'ベストベンチャー100に3年連続で選出',
  },

  values: {
    title: '企業理念',
    subtitle: 'Values',
    sixValues: '6つの価値観',
    clientFirst: 'クライアント第一',
    clientFirstDesc: '私たちは、クライアントの成功を何よりも優先します。すべての戦略、すべての決定、すべての行動は、私たちが奉仕する人々に最大の価値を提供することを目的としています',
    dataDriven: 'データ駆動型の卓越性',
    dataDrivenDesc: '私たちは、前進への道を照らすデータの力を信じています。私たちの決定は、厳密な分析と測定可能な成果に基づいています',
    innovation: 'イノベーションと機敏性',
    innovationDesc: '急速に進化するデジタル環境において、私たちは変化を受け入れ、新しいアプローチを試し、市場の動向に迅速に適応することで先を行きます',
    integrity: '誠実さと透明性',
    integrityDesc: '私たちは、正直なコミュニケーション、倫理的な実践、透明性のある報告を通じて信頼を築きます。クライアントは常に自分の立場を知っています',
    collaboration: '協力的パートナーシップ',
    collaborationDesc: '私たちは、クライアントと共に働きます。クライアントの成功は、真の協力と共有されたコミットメントを通じて達成されます',
    improvement: '継続的改善',
    improvementDesc: '私たちは現状に満足することはありません。私たちは常に方法を洗練し、知識を拡大し、継続的にサービスを改善し続けます',
    living: '価値観の実践',
    livingText: 'これらの価値観は単なる言葉ではありません。それらは私たちの文化の基盤であり、日々の仕事を導く羅針盤です。TradFitチームのすべてのメンバーがこれらの原則を体現し、クライアントが卓越したサービスだけでなく、信頼、卓越性、共有された成功に基づくパートナーシップを受け取ることを保証します。',
    workWithUs: '私たちと働く',
  },

  // Business Page
  business: {
    title: '事業内容',
    subtitle: 'Business Overview',
    marketingConsultingTitle: 'マーケティングコンサルティング',
    marketingConsultingDesc: 'ビジネス成長を促進する戦略的マーケティング計画と実行支援',
    newBusinessTitle: '新規事業開発',
    newBusinessDesc: '新規事業の立ち上げと拡大のための包括的なサポート',
    crmConsultingTitle: 'CRMコンサルティング',
    crmConsultingDesc: '顧客関係管理の最適化と実装',
    hrConsultingTitle: '人事コンサルティング',
    hrConsultingDesc: '人事戦略と人材育成ソリューション',
    dataMarketingTitle: 'データマーケティング',
    dataMarketingDesc: 'マーケティング最適化のための高度なデータ分析とインサイト',
    adMarketingTitle: '広告マーケティング',
    adMarketingDesc: '包括的な広告キャンペーン管理と最適化',
    snsMediaMarketingTitle: 'SNS・メディアマーケティング',
    snsMediaMarketingDesc: 'ソーシャルメディア戦略とコンテンツマーケティングソリューション',
    webCreationTitle: 'Web制作',
    webCreationDesc: 'プロフェッショナルなウェブサイトデザインと開発サービス',
    videoBrandingTitle: '動画ブランディング',
    videoBrandingDesc: '動画制作とブランドストーリーテリングサービス',
    systemDevelopmentTitle: 'システム開発',
    systemDevelopmentDesc: 'カスタムソフトウェアとシステム開発ソリューション',
    learnMore: '詳細を見る',
    integratedApproach: '統合的なアプローチ',
    integratedText: '私たちは、マーケティング、テクノロジー、クリエイティブの各分野における専門知識を統合し、お客様のビジネス目標達成をサポートします',
    discussProject: 'プロジェクトについて相談する',
    
    // Service 1: Hospitalia
    hospitaliaTitle: 'Hospitalia 音声AIソリューション',
    hospitaliaDesc: '日本初のAlexa SP認定を受けた音声AIプラットフォーム。観光・ヘルスケア・自治体向けに業界特化型ソリューションを提供',
    hospitaliaDetail1Title: '業務負荷を劇的に軽減',
    hospitaliaDetail1: 'Hospitaliaを使うことで問い合わせの自動化、多言語対応、タスク管理をシンプルに行うことで、現場の業務負荷を劇的に改善します。スタッフは客室からの電話や受付での問い合わせ対応に追われる事なく、顧客のリクエストへ対応することが可能になります',
    hospitaliaDetail2Title: '多種多様なニーズへ対応',
    hospitaliaDetail2: '宿泊施設におけるゲストの体験価値向上をはじめ、医療・介護現場での効率的な業務支援など、各業界の特有ニーズに応じた柔軟で効果的なソリューションを提供します。お客様の課題に寄り添い、最適な解決策を提案することで、業務の効率化やサービス品質の向上をサポートします',
    hospitaliaDetail3Title: 'スマートスピーカーをハブにした新たな体験を提案',
    hospitaliaDetail3: 'スマートスピーカーをハブに、さまざまなデバイスやサービスを連携させることで、より便利で快適な環境を提供します。例えば、宿泊施設ではスマートスピーカーを通じて客室内の照明や空調の操作、フロントへの問い合わせ、ルームサービスの注文などが音声で簡単に行えるようになります。また、医療・介護現場では、音声アシスタントを活用して、ナースコール対応を軽減します。これにより、現場の業務効率を高めると同時に、利用者にとっても直感的で使いやすい体験を提供します',
    
    // Service 2: AI Consulting
    aiConsultingTitle: '生成AIコンサルティング・開発支援',
    aiConsultingDesc: '最先端の生成AI技術を活用し、企業の業務効率化とイノベーション創出を支援。戦略立案から実装まで一貫サポート',
    aiConsultingDetail1Title: '背景と必然性',
    aiConsultingDetail1: '生成AIの活用は、これからの企業運営にとって生命線とも言える課題です。生成AIを活用できる企業とそうでない企業の生産性は、加速度的に開いていくと弊社は考えています。生成AIの活用領域は、システムの効率化だけに止まらず、通常業務・バックオフィス業務・管理業務など、あらゆる業務の生産性を飛躍的に向上させる事が可能です。弊社の生成AI開発・活用のノウハウをお客様に提供することで、働く方々のワークライフバランスの向上や、より安定した収益性の改善に貢献ができると考えています',
    aiConsultingPoint1: 'DX推進',
    aiConsultingPoint1Desc: '企業などにおける様々な業務を生成AIにより効率化が可能です。あらゆる側面から、DXの推進が可能です。例えば、営業補助、各種問い合わせ、広告・マーケティングなどDX化が可能な業務範囲は多岐に渡ります',
    aiConsultingPoint2: 'リスキリングによる内製化を支援',
    aiConsultingPoint2Desc: '個人単位で生成AIの活用範囲が広がることで、組織全体の生産性が飛躍的に高まります。企業における生成AI活用の内製化を弊社が伴走支援し、さらなる業務効率化が可能です',
    aiConsultingPoint3: '高速な新規事業開発',
    aiConsultingPoint3Desc: '生成AIを正しく活用することで、飛躍的に新規事業開発を進めることが速くなります',
    aiConsultingDetail2: '',
    aiConsultingDetail3: '',
    
    // Service 3: Website Creation
    websiteCreationTitle: '生成AIWebサイト作成サービス',
    websiteCreationDesc: '生成AIの力でより簡単に、より伝わりやすいWebサイトを構築',
    websiteCreationDetail1: '貴社のウェブサイトを生成AIの力で刷新します',
    websiteCreationDetail2: 'ご要件を伺い、最短2−3週間で貴社のホームページを作成いたします。現代のホームページに必要なセキュリティと表示速度を担保し、訪問者に使いやすいホームページを構築いたします',
    websiteCreationDetail3: '従来型のホームページ作成サービスは、会社の情報やお問い合わせフォームの設置などの基本的な要素のみを提供するサービスが主流です',
    websiteCreationDetail4: '本サービスでは、ECサイトの構築やCMS(コンテンツマネジメントシステム)、ブログの設置など、幅広いご要望にお応えすることが可能です',
    websiteCreationDetail5: 'また、サイト公開後の保守・メンテナンスは弊社が対応します。お客様側での作業は不要です',
    closeModal: '閉じる',
    contactUs: '問い合わせる',
    mainServicesTitle: '主要サービス',
    mainServicesSubtitle: '最先端のAI技術と深い業界知見を組み合わせ、お客様のビジネス課題に最適なソリューションを提供します',

    // Service 4: Cyber Security
    cyberSecurityTitle: 'サイバーセキュリティー対策サービス',
    cyberSecurityDesc: '20年以上インシデントゼロの圧倒的実績。ADサーバーから全端末まで、お客様のニーズに合わせた柔軟な導入を実現',
    cyberSecurityDetail1Title: '圧倒的な実績',
    cyberSecurityDetail1: '弊社の提案するサイバーセキュリティ製品は、20年以上にわたりインシデントゼロという圧倒的な実績を誇ります',
    cyberSecurityDetail2Title: '一部のサーバー・端末から導入可能',
    cyberSecurityDetail2: '認証基盤である AD(アクティブディレクトリ）サーバーのみの導入から、端末全体への導入まで、ニーズに合わせて柔軟に対応できます',
    cyberSecurityDetail3Title: '大企業や病院など、多数のお客様が導入済み',
    cyberSecurityDetail3: 'セキュリティ要件の厳しい大企業・病院などへの導入が急増しています',

    // Service 5: AI Marketing
    aiMarketingTitle: '生成AIマーケティング支援サービス',
    aiMarketingDesc: '生成AIでコンテンツ制作を革新。データドリブンなターゲティングと最適化でマーケティングROIを最大化し、ブランド価値を向上',
    aiMarketingDetail1Title: '生成AIによるコンテンツ制作の革新',
    aiMarketingDetail1: '生成AIを活用することで、高品質なマーケティングコンテンツを従来の数倍のスピードで制作できます。ブログ記事、SNS投稿、広告コピー、メールマガジンなど、あらゆるコンテンツを自動生成・最適化し、マーケティング活動の生産性を飛躍的に向上させます。',
    aiMarketingDetail2Title: 'データドリブンなターゲティングと最適化',
    aiMarketingDetail2: '生成AIと機械学習を組み合わせることで、顧客データを深く分析し、最適なターゲティング戦略を立案します。広告配信の自動最適化、パーソナライズされたメッセージング、リアルタイムのA/Bテストにより、マーケティングROIを最大化します。',
    aiMarketingDetail3Title: 'ブランド強化と顧客エンゲージメント向上',
    aiMarketingDetail3: '生成AIを活用したブランドストーリーテリングにより、顧客との深い関係性を構築します。SNSマーケティング、インフルエンサー連携、コミュニティ形成など、多角的なアプローチで顧客エンゲージメントを高め、長期的なブランド価値を向上させます。',
  },

  // Stats Page
  // Works Page
  works: {
    heroTitle: '制作実績 — Works',
    description: 'TradFitが生成AIで制作した、公開中のWebサイトをご紹介します',
    siteLink: 'サイトを見る',
    comingSoon: '準備中',
    items: [
      { name: '株式会社エイオーランド', desc: '茨城県水戸市の不動産売買・投資コンサルティング' },
      { name: '岩崎工業株式会社 ROOFIX', desc: '超軽量太陽光パネルとポリウレア防水の一体工法' },
      { name: '株式会社TBM健康美容研究所', desc: '群馬県高崎市の健康・美容総合研究所' },
      { name: '麺屋加藤兵太郎商店', desc: '小田原名物・極上味噌ラーメン専門店' },
      { name: 'Hotel Bireiz', desc: '群馬県前橋市のレジャーホテル' },
      { name: 'JEANA HARBOR 関根慶介', desc: 'つむじ・頭皮の悩み専門サロン' },
      { name: '灯珈琲', desc: '世田谷・代沢の自家焙煎コーヒー専門店' },
      { name: '株式会社ルヴィラ', desc: 'AIで会社の成長を止める滞りを改善' },
      { name: 'YUSUKE GOTO Official Site', desc: '頭皮・美髪改善アドバイザー' },
      { name: '縁結び 和はは', desc: '' },
    ],
  },

  // Stats Page
  stats: {
    title: '実績',
    description: '業種・業態・規模問わず生成AIの力でお客様の成長を支援しています',
    clientCategoriesTitle: '取引先（一部抜粋）',
    clientCategories: ['美容', 'エステ', 'ブライダル', '宝飾', '個人事業主', 'IT', '通信', '金融', 'メガバンク', '地銀', '信用金庫', '信託銀行', '生保', '損保', 'リース', '建設', 'ゼネコン', '不動産', 'デベロッパー', '電鉄', '商業施設', 'レジデンス', '施工管理', '塗装', '製薬', '病院', 'クリニック', '介護', 'ホテル', '旅館', '民泊', '飲食', '清掃', 'メーカー', '小売', 'アパレル', '卸売', '配送', '倉庫', '士業', '会計事務所', 'コンサルティング', '人材紹介', '学校法人', 'NPO法人'],
  },

  // News Page
  news: {
    title: 'お知らせ',
    subtitle: 'NEWS',
    noArticles: '記事がありません',
    backToList: '一覧へ戻る',
    articleNotFound: '記事が見つかりません',
    articleNotFoundDesc: 'お探しの記事は削除されたか、URLが間違っている可能性があります。',
    previousArticle: '前の記事',
    nextArticle: '次の記事',
    relatedArticles: '関連記事',
    noContent: '本文がありません。',
    share: 'Share',
    viewOriginal: '元記事を見る',
    pressRelease: 'プレスリリース',
    companyNews: '企業ニュース',
    event: 'イベント',
    award: '受賞',
    item1: 'TradFit、大手テクノロジー企業との新たな戦略的パートナーシップを発表',
    item2: '年末決算：マーケティングコンサルティングサービスで記録的な成長',
    item3: 'TradFit、2025年次マーケティングサミットを開催',
    item4: '東京都内に新オフィスを開設',
    item5: 'TradFit、データ分析チームを拡大',
    item6: '今年のトップマーケティングコンサルティング企業として認定',
    item7: '新しいCRMコンサルティングサービスラインを開始',
    item8: 'TradFit、5周年を祝う',
  },

  // SEO
  seo: {
    homeTitle: '東京 生成AI・音声AI・サイバーセキュリティー TradFit株式会社 | AIソリューション',
    homeDescription: 'TradFit株式会社は東京を拠点とする生成AI・音声AIのリーディングカンパニーです。Hospitalia音声AIソリューション、生成AIコンサルティング・開発支援、サイバーセキュリティー対策サービス、生成AIマーケティング支援サービスを提供。ビジネスのDX推進を支援します。',
    homeKeywords: '生成AI, 音声AI, AIコンサルティング, サイバーセキュリティー, 生成AIマーケティング, DX推進, 東京',
    aboutTitle: '東京 会社概要 TradFit株式会社 | 生成AI・音声AI企業情報',
    aboutDescription: 'TradFit株式会社の会社概要。東京都千代田区に本社を置く生成AI・音声AIのリーディングカンパニー。企業理念、ビジョン、会社情報をご紹介します。',
    aboutKeywords: '会社概要, TradFit, 生成AI企業, 音声AI企業, 東京, 千代田区',
    businessTitle: '東京 事業内容 TradFit株式会社 | 音声AI・生成AI・サイバーセキュリティー・マーケティング',
    businessDescription: 'TradFit株式会社の事業内容。Hospitalia音声AIソリューション、生成AIコンサルティング・開発支援、サイバーセキュリティー対策サービス、生成AIマーケティング支援サービスの4大コアサービスを提供。',
    businessKeywords: '事業内容, 生成AIコンサルティング, 音声AI, Hospitalia, サイバーセキュリティー, 生成AIマーケティング, DX推進, 東京',
    newsTitle: '東京 お知らせ TradFit株式会社 | 生成AI・音声AI最新情報',
    newsDescription: 'TradFit株式会社のお知らせ・ニュース一覧。最新情報、プレスリリース、イベント情報をお届けします。',
    newsKeywords: 'お知らせ, ニュース, プレスリリース, 生成AI, 音声AI, 東京',
    contactTitle: '東京 お問い合わせ TradFit株式会社 | 生成AI・音声AIご相談',
    contactDescription: 'TradFit株式会社へのお問い合わせページ。AIソリューション導入のご相談を承ります。',
    contactKeywords: 'お問い合わせ, 相談, 生成AI相談, 東京',
    statsTitle: '東京 実績・数字 TradFit株式会社 | 生成AI・音声AI企業実績',
    statsDescription: 'TradFit株式会社の実績・数字。生成AI・音声AI分野での豊富な導入実績と、企業のDX推進を支援した成果をご紹介します。',
    statsKeywords: '実績, 数字, 導入実績, 生成AI, 音声AI, 東京',
    worksTitle: '制作実績 | TradFit株式会社',
    worksDescription: 'TradFitが生成AIで制作した公開中のWebサイト一覧。不動産、飲食、美容、ホテルなど多業種の実績をご覧いただけます。',
    worksKeywords: '制作実績, Web制作, 生成AI, ホームページ制作, TradFit',
    valuesTitle: '企業理念 | TradFit株式会社',
    valuesDescription: 'TradFit株式会社の企業理念。お客様第一主義、データドリブン、イノベーション、誠実さ、協働、継続的改善の6つの価値観をご紹介します。',
    valuesKeywords: '企業理念, 価値観, ミッション, TradFit',
    recruitmentTitle: '採用情報 | TradFit株式会社',
    recruitmentDescription: 'TradFit株式会社の採用情報。生成AI・音声AIのリーディングカンパニーで、あなたのキャリアを次のステージへ。',
    recruitmentKeywords: '採用, 求人, キャリア, AI企業, 東京',
    privacyTitle: 'プライバシーポリシー | TradFit株式会社',
    privacyDescription: 'TradFit株式会社のプライバシーポリシー。個人情報の取扱いに関する方針を定めています。',
    privacyKeywords: 'プライバシーポリシー, 個人情報保護, TradFit',
    securityTitle: '情報セキュリティ | TradFit株式会社',
    securityDescription: 'TradFit株式会社の情報セキュリティ方針。お客様のデータ保護とセキュリティ対策についてご紹介します。',
    securityKeywords: '情報セキュリティ, データ保護, セキュリティポリシー, TradFit',
    servicePageTitle: '提供サービス',
    servicePageProcess: '進め方',
    servicePageBenefits: '導入メリット',
    servicePageCtaPrefix: 'について',
    servicePageCtaHighlight: 'まずは無料相談から',
    servicePageCtaDesc: '貴社の課題やご要望をお聞かせください。TradFitのエキスパートが最適なソリューションをご提案します',
  },

  // Contact Page
  contact: {
    title: 'お問い合わせ',
    subtitle: 'お気軽にご連絡ください',
    sendMessage: 'メッセージを送る',
    name: 'お名前',
    email: 'メールアドレス',
    company: '会社名',
    phone: '電話番号',
    subject: '件名',
    message: 'メッセージ',
    send: 'メッセージを送信',
    sending: '送信中...',
    successMessage: 'メッセージをありがとうございます。すぐにご連絡いたします！',
    errorMessage: 'メッセージの送信中にエラーが発生しました。もう一度お試しください。',
    selectSubject: '件名を選択してください',
    generalInquiry: '一般的なお問い合わせ',
    aiConsulting: '生成AIコンサルティング・開発支援',
    cyberSecurity: 'サイバーセキュリティー対策サービス',
    hospitalia: 'Hospitalia 音声AIソリューション',
    partnership: 'パートナーシップ・業務提携',
    career: '採用・キャリアに関するお問い合わせ',
    other: 'その他',
    contactInfo: '連絡先情報',
    address: '住所',
    addressText: 'TradFit株式会社\n〒100-0005\n東京都千代田区丸の内一丁目６番５号\n丸の内北口ビルディング９階',
    businessHours: '営業時間',
    businessHoursText: '月曜日 - 金曜日：午前9時 - 午後6時（JST）\n土曜日、日曜日、祝日：休業',
    followUs: 'フォローする',
    characters: '文字',
  },

  articles: [
    {
      date: '2026.01.07',
      category: '事例・リリース',
      title: '元野村證券専務、元野村総合研究所副会長の百瀬裕規氏がTradFit社のエグゼクティブ‧アドバイザーに就任',
      content: `      <p><strong>生成AI・音声AI・IoT・ロボティクス・生体認証等のテクノロジーを活用し、各種業界の人手不足解消事業「Hospitalia」を中心に生成AIコンサルティング事業や生成AI開発事業など複数のサービスを提供するTradFit(トラッドフィット)株式会社(本社:東京都千代田区、代表取締役:戸田良樹、以下「TradFit」)は、更なる経営体制の強化ならびに事業拡大の向上などを目的として、百瀬裕規氏をエグゼクティブ・アドバイザーに就任したことをお知らせします。</strong></p>

      <figure class="wp-block-image">
        <img src="https://prcdn.freetls.fastly.net/release_image/33116/187/33116-187-06be5066e3e4bc5b597aab5ac155500c-3900x2601.jpg?width=1950&height=1350&quality=85%2C65&format=jpeg&auto=webp&fit=bounds&bg-color=fff" alt="" class="w-full h-auto rounded-lg my-6">
      </figure>

      <h3><strong>■ 背景・課題</strong></h3>
      <p>観光・ホテル・旅館・病院・不動産・介護施設・全国各地の地域事業者・行政自治体は昨今人手不足などの大きな課題に直面しています。</p>

      <p>上記の業界や付随する関連業界で加速化するDX(デジタルトランスフォーメーション)、その中でもAI分野への期待は高く、TradFitはクライアントや協業(共創)パートナー企業等と共にあらゆる側面から共創、変革し続け、三方よしで日本の各業界などが抱えている大きな課題を解決していきます。</p>

      <p>TradFitは観光・ホテル・旅館・不動産・病院・介護施設・全国各地の地域事業者・行政自治体などに特化したAIやソフトウェアなどを開発、運用をしています。</p>

      <p>TradFitの強みは、各業界のクライアントや国内外の企業等とパートナーシップを構築し、1社では解決できない様々な課題を共創しながら解決し、ビジネスを加速する守りと攻めの知財戦略策定及び知財の取得、国内・海外展開に向けた特許ポートフォリオの構築を加速していることです。</p>

      <p>この度、日本を含む国際的な市場、各業界や産業で複雑な課題に向き合ってきたリーダーである百瀬裕規氏をエグゼクティブ・アドバイザーに迎え入れることで、更なる経営体制の強化、事業拡大の向上などを推進します。</p>

      <h3><strong>■TradFit エグゼクティブ・アドバイザー 百瀬裕規 コメント</strong></h3>
      <p>この度、TradFitのエグゼクティブ・アドバイザーに就任させて頂きました百瀬です。前職のご縁で戸田社長をご紹介頂き、特に日本の社会課題を三方よしで解決していくという想いに強く共感しました。</p>

      <p>あらゆる業界や産業課題に対して、三方よしで国内外の企業とのパートナーシップを大切にし、1社では解決できない様々な課題を各社と連携しながら解決を試み、より良い社会を実現していこうという考え方に大きな可能性と社会的意義を感じました。</p>

      <p>私自身は金融という世界に長く籍を置き、様々な産業や企業の発展に貢献し、より良い社会の実現に力を注いで参りました。</p>

      <p>築き上げてきたご縁やネットワーク、金融や産業に係わる知見、企業経営者としてのキャリアをベースに、TradFit社が抱えている理念を実現し、TradFit社が今後飛躍的に発展することに全力で支援をさせて頂く所存です。</p>

      <h3><strong>■TradFit エグゼクティブ・アドバイザー 百瀬裕規 略歴</strong></h3>
      <p>1985年 大阪大学経済学部卒業後、野村證券株式会社入社。<br>
      2008年 同社執行役大阪支店長。<br>
      2013年 同社常務大阪駐在兼大阪支店長。<br>
      2017年 同社専務大阪駐在。<br>
      2019年 株式会社野村総合研究所取締役副会長。<br>
      2025年 TradFit株式会社 エグゼクティブ・アドバイザーに就任。</p>

      <h3><strong>■TradFit 代表取締役 戸田良樹 コメント</strong></h3>
      <p>この度、日本の各業界が抱えている大きな課題解決の実現に向けた更なる経営体制の強化ならびに事業拡大の向上などを目的に百瀬さんにTradFitのエグゼクティブ・アドバイザーに就任頂きました。</p>

      <p>百瀬さんは、野村グループにおいて野村證券専務大阪駐在、野村総合研究所副会長を経て、現在は世界的な大手著名PEファンドの共同会長を務められています。</p>

      <p>野村證券においては、大阪、東京で27年間投資銀行業務に従事し、数多くの日本企業のM&A、投資、資金調達案件を手掛けた経験と実績を保有されています。</p>

      <p>TradFitの経営体制の強化ならびに事業拡大の向上など、事業推進において、経営リーダーとして幅広い産業や業界における実績、経験、ネットワークを構築されている百瀬さんから多くを学び、今後のTradFitの飛躍的な成長に挑戦していく所存です。</p>

      <h3><strong>■TradFitの展開するサービスについて</strong></h3>
      <p>TradFitは、「生成AI・音声AI・IoT・ロボティクス・生体認証テクノロジー等を活用した観光・ホテル・旅館・不動産・病院・介護施設・全国各地の地域事業者・行政自治体等の収益性改善等のサービスプラットフォーム」事業を展開。人手不足問題等の大きな社会課題の解決を推進し、サービスを提供しています。</p>

      <p>自律走行ロボティクスとのシステム連携などを完了し、各業界のクライアントや国内外の協業(共創)パートナー企業等と共に様々な課題を解決し、ビジネスを加速する守りと攻めの知財戦略策定及び知財の取得、国内・海外展開に向けた特許ポートフォリオの構築を加速しています。</p>

      <p>TradFitのサービスプラットフォームを通じて事業者は、業務の効率化や人手不足を補うサービスにより、コスト削減や売上増を可能とし、さらには国内外の協業(共創)パートナーとオープンイノベーションを推進しているため、新たなビジネスの展開可能性があります。</p>

      <p>TradFitは、国内外の協業(共創)パートナー企業とともに今後も日本と世界の企業等が日々直面している社会課題を解決し、持続可能な未来を牽引するために、新しい社会インフラを目指してまいります。</p>

      <h3><strong>■ TradFitについて</strong></h3>
      <p>【会社名】TradFit(トラッドフィット)株式会社<br>
      【所在地】東京都千代田区丸の内一丁目6番5号 丸の内北口ビルディング9階<br>
      【代表者】代表取締役 戸田 良樹<br>
      【設立】 2017年8月<br>
      【資本金】100百万円<br>
      【Webサイト】<a target="_blank" rel="nofollow ugc noopener" href="https://company.tradfit.com">https://company.tradfit.com</a></p>

      <h3><strong>■本件に関する問い合わせ</strong></h3>
      <p>TradFit株式会社<br>
      E-mail:info@tradift.com</p>

      <p><strong>■本件に関する報道関係者からのお問い合わせ</strong><br>
      E-mail:contact@tradfit.com</p>

      <p><strong>■ 記事リンク（PRTIMES）</strong><br>
      <a target="_blank" rel="nofollow ugc noopener" href="https://prtimes.jp/main/html/rd/p/000000187.000033116.html">https://prtimes.jp/main/html/rd/p/000000187.000033116.html</a></p>

      `


    },
    {
      date: '2025.12.02',
      category: '事例・リリース',
      title: 'トラベルボイスに掲載されました。TradFit社、NECネッツエスアイと販売店契約、AI音声サービス「ホスピタリア」のサポート体制を強化',
      content: `<p>宿泊施設向けにデジタルソリューションを提供するTradFit(トラッドフィット)社は、ホテル業界向けAI音声サービス「Hospitalia(ホスピタリア)」について、NECネッツエスアイ株式会社(※)(本社:東京都港区、以下「NECネッツエスアイ」)と販売店契約の締結をすすめている。これにより、日本全国のホテルに向けた販売・サポート体制を強化する。</p>
  <img loading="lazy" width="800" height="288" src="https://www.travelvoice.jp/wp-content/uploads/2025/12/thumb_w800_a125cc1c-13b3-4248-bb70-2ac09dff0d5f.jpeg" alt="" class="w-full h-auto rounded-lg my-6" />
  <p>TradFit社は、Amazonから「Alexa Smart Properties for Hospitality」のソリューションプロバイダーとして日本で初めて認定され、AmazonのAIを取り入れたホテル業界向け「Hospitalia」の開発と展開を行っている。</p>
  <p>Hospitaliaは、AmazonのAIアシスタントAlexa(アレクサ)をベースにしたホスピタリティ産業向けのサービスで、音声とスマートディスプレイ上のテキスト、画像や映像でユーザーをサポートする。</p>
  <p><strong>■リンク</strong><br><a href="https://www.travelvoice.jp/20251202-158844" target="_blank" rel="noreferrer noopener">https://www.travelvoice.jp/20251202-158844</a></p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>
  <p><strong>■本件に関する報道関係者からのお問い合わせ</strong><br>E-mail:contact@tradfit.com</p>`
    },
    {
      date: '2025.11.27',
      category: '事例・リリース',
      title: 'TradFitは日本全国の販売・サポート体制を強化。Amazon Echo法人版ホテル客室向けサービス『Hospitalia』を業務提携先(※)と共に全国展開',
      content: `<p><span style="color: #546e7a;">~各業務提携先(※)と共に加速するAI活用とホテル業界のDX化を強力に支援~</span></p>
  <p><strong>TradFit株式会社(本社:東京都千代田区、以下「TradFit」)は、当社が提供するホテル業界向けサービス『Hospitalia(ホスピタリア)』の販売に関し、NECネッツエスアイ株式会社(※)(本社:東京都港区、以下「NECネッツエスアイ」)と販売店契約の締結を進めています。</strong></p>
  <p><strong>本契約により、『Hospitalia』は日本全国のホテルへこれまで以上に手厚い販売・サポート体制の提供が可能となりました。</strong></p>
  <p><strong>ホテル業界で加速化するDX(デジタルトランスフォーメーション)、そのなかでもAI分野への期待は高く、当社はお客様とともにこれからも改革し続け、新しい時代を構築するお客様のよきパートナーであり続けることを目指していきます。</strong></p>
  <p><strong>■本製品『Hospitalia』の特徴</strong><br>TradFitは、AmazonよりAlexa Smart Properties for Hospitalityのソリューションプロバイダーとして日本で初めて認定され、パートナーシップを組み、AmazonのAIを取り入れてホテル業界向けに『Hospitalia』サービス開発と展開を行なっている国内唯一の日本のスタートアップです。</p>
  <img src="https://prcdn.freetls.fastly.net/release_image/33116/186/33116-186-e9cb6a13abe1491540e01c87160e82ff-850x446.jpg?width=1950&height=1350&quality=85&format=jpeg&auto=webp&fit=bounds&bg-color=fff" alt="" class="w-full h-auto rounded-lg my-6" />
  <p>「生成AI・音声AI・IoT・ロボティクス等のテクノロジーを活用し、ホテル業界向けにさらなる収益性改善を支援するサービスプラットフォーム」事業を展開。主にホテル業界などの人手不足課題などの大きな社会課題の解決を推進し、サービスを提供しています。</p>
  <p><strong>■ TradFitの強みや特徴</strong><br>TradFitは、ホテル業界の働き方に合わせたサービス提供や、ホテル業界が抱える課題を解決可能な特許ポートフォリオを有する強みを保有しています。</p>
  <p>TradFitは、サービスプラットフォームを通じ、ホテル業界に対して、国内外の宿泊ゲストの体験価値の向上、各種お問い合わせやオーダー対応(多言語対応)など、ホテルスタッフの業務負荷軽減や人手不足を補うサービス提供を行っています。</p>
  <p>TradFitは、国内外の協業(共創)パートナー企業とともに今後も世界が日々直面している社会課題を解決し、持続可能な未来を牽引するために、新しい社会インフラを目指してまいります。</p>
  <p><strong>■ TradFitについて</strong><br>【会社名】TradFit(トラッドフィット)株式会社<br>【所在地】東京都千代田区丸の内一丁目6番5号 丸の内北口ビルディング9階<br>【代表者】代表取締役 戸田 良樹<br>【設立】 2017年8月<br>【資本金】100百万円<br>【サービスWeb】<a href="https://hospitalia.jp/" target="_blank" rel="noreferrer noopener">https://hospitalia.jp</a><br>【コーポレートWeb】<a href="https://company.tradfit.com/" target="_blank" rel="noreferrer noopener">https://company.tradfit.com/</a></p>
  <img src="https://prcdn.freetls.fastly.net/release_image/33116/186/33116-186-e659118fc5c31b18ebeff2c7ce8768ab-850x306.jpg?width=1950&height=1350&quality=85&format=jpeg&auto=webp&fit=bounds&bg-color=fff" alt="" class="w-full h-auto rounded-lg my-6" />
  <p><strong>■リンク</strong><br><a href="https://prtimes.jp/main/html/rd/p/000000186.000033116.html" target="_blank" rel="noreferrer noopener">https://prtimes.jp/main/html/rd/p/000000186.000033116.html</a></p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>
  <p><strong>■本件に関する報道関係者からのお問い合わせ</strong><br>E-mail:contact@tradfit.com</p>`
    },
  {
    date: '2025.11.21',
    category: '事例・リリース',
    title: 'Amazon Alexa Smart Propertiesの活用により観光・宿泊業界、ヘルスケア業界、自治体の業務効率化と生産性の向上をサポート―インバウンドの増加や人口減少に伴う人手不足の解消や多言語対応に貢献',
    content: `<img src="https://dhhmpfovkf2ub.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/tradfit/tradfit_main.jpg" alt="TradFit株式会社 代表取締役 戸田　良樹 氏" class="w-full h-auto rounded-lg my-6" />
    <h5><strong>Alexa Smart Propertiesを活用したサービスの特徴</strong></h5>
<ul>
<li>音声による宿泊施設のオーダー受付の実現により、フロントへの入電率を半減</li>
<li>マルチリンガル対応により宿泊ゲストへのスムーズな対応、インバウンド需要に貢献</li>
<li>堅牢なセキュリティにより、不特定多数の利用が行われる環境でも安全な運用が可能</li>
</ul>

<p><strong>会社名:</strong>TradFit株式会社</p>
<p><strong>業種:</strong>クラウドAIを活用した音声データプラットフォームの構築及び運営</p>
<p><strong>設立:</strong>2017年8月</p>
<p><strong>所在地:</strong>〒100-0005 東京都千代田区丸の内一丁目6番5号 丸の内北口ビルディング9階</p>
<p><strong>ホームページ:</strong><a href="https://company.tradfit.com/" target="_blank">https://company.tradfit.com/</a></p>

<p><a href="https://ds6yc8t7pnx74.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/pdf/AmazonAlexa_SP_TradFit.pdf" target="_blank" class="inline-block px-6 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors">PDF版をダウンロード</a></p>

<h3><strong>宿泊施設、医療・介護現場、自治体の課題解決の鍵となる「Hospitalia」</strong></h3>

<p>音声や生成AI、ロボティクス、IoTテクノロジーなどの活用により、観光や宿泊、ヘルスケア業界、自治体に向けて世界中の人々に、より良い暮らしを実現するサービスを提供し、社会課題の解決を目標に掲げているTradFit。同社の音声AIソリューションは、業務の効率化のみならず、社会課題の解決に貢献しています。そしてTradFitは、Amazon Alexaをベースにした宿泊施設をはじめ、医療・介護といったホスピタリティ産業、自治体向けの「Hospitalia(ホスピタリア)」と呼ばれるサービスを展開。音声とスマートディスプレイ上のテキスト、画像や映像などを通じて、顧客体験の向上や従業員の業務を支援しています。</p>

<p>代表取締役を務める戸田 良樹 氏は、「TradFitは創業期から知財戦略に注力して事業に取り組んでいます。当社の大きな強みが知財を活用した『三方よし』での事業展開です。観光・宿泊業界のみならず、ヘルスケア業界、自治体などの売上向上や、コスト削減に直結するようなビジネスモデル特許、基本特許を数多く保有しています。この知財戦略により差別化を徹底しています。そのうえで、顧客や提携先とともに日本が抱えている社会課題の解決や、各業界の顧客課題の解決、自社の成長にわたって、三方よしで進めています」と強調します。</p>

<p>Alexa開発者コミュニティのなかで特に積極的に活動し、貢献している開発者や技術者を称えるAlexa Championとして選出された実績を持つ取締役CTO 伊東 知治 氏は、「TradFitは会話体験を向上させるための技術開発にも継続的に取り組んできました。当社が保有しているこれまで取得できていなかったユニークなデータを取得し、業態ごとに異なる宿泊施設の会話ノウハウや特色を組みあわせ、多彩なパターンに合致した会話のデザインを設計できる点もTradFitの大きな強みです。また、生成AI技術を活用した音声認識の精度向上にも注力し続けています」と強調します。</p>

<img src="https://dhhmpfovkf2ub.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/tradfit/tradfit_003.jpg" alt="TradFit株式会社 取締役CTO 伊東 知治 氏" class="w-full h-auto rounded-lg my-6" />
<p class="text-sm text-gray-600">TradFit株式会社 取締役CTO 伊東 知治 氏</p>

<h3><strong>宿泊業界が抱える課題を音声と生成AIで解決する</strong></h3>

<p>宿泊業界では、近年さまざまな課題が浮上しているといいます。宿泊業界では、従業員に高い接客スキルが求められるとともに、24時間体制で宿泊客からの要望に応えなければなりません。さらにインバウンド需要の拡大に伴い、海外からの宿泊者を取り入れるための多言語対応も求められています。こうしたなかで、業務の負荷が大きくなり、慢性的な人手不足も課題として浮上。人件費も上昇傾向にあり、収益率を向上させるための業務効率化は急務となっています。</p>

<p>「宿泊業界は人手不足やインバウンドの増加による多言語対応など、多くの課題が浮上しています。TradFitは、生成AIや音声AI、そしてAlexaをビジネス向けに展開していくにあたって、『社会や業界が抱えている課題解決に、最も資するサービスを提供できる業界はどこなのか』ということを考え、業界の現場に赴き、かつ国内外の旅行者に対しても生々しいインタビューを実施し、試行錯誤を重ねた結果、まずは、宿泊業界に注力することになりました。それ以降、Hospitaliaのブランドで、宿泊業界が抱える課題を解決するための音声×AIソリューションの提供を行ってきました」(戸田氏)</p>

<h3><strong>Alexa Smart Propertiesによってインバウンドに対応、フロントへの入電率も半減</strong></h3>

<p>Alexa Smart Propertiesは、宿泊施設、高齢者施設や自治体向けにカスタマイズされたサービスで、2023年12月から日本で提供が開始されています。TradFitは、Alexa Smart Properties for HospitalityのソリューションプロバイダーとしてAmazonと契約し、ホーム画面や通知機能のカスタマイズのほか、固有のカスタムスキルを構築し、より宿泊施設のニーズに合致したサービスを提供しています。</p>

<p>堅牢なセキュリティにより、不特定多数が利用する環境においても安全に運用できる点は、Alexa Smart Propertiesの大きなメリットの1つといえます。伊東氏は、「Alexa Smart Propertiesでは、ユーザーの発話履歴や音声アクティビティが保護され、プライバシーとセキュリティが両立されており、安心して利用できる環境が整えられています」と語ります。</p>

<p>小田急ホテルセンチュリーサザンタワーでは、全375室にAlexa Smart Properties対応のEcho Showを導入。インバウンド需要に対する多言語対応を果たしながら、宿泊客からの貸出備品などのオーダーに対して音声による受付を実現。一日平均30件ほどあったAlexaへの問いかけのうち、電話に誘導されたのは10件のみでした(※1)。また、龍宮城スパホテル三日月では、479の全客室にAlexa Smart Propertiesを導入しています。館内施設やアクティビティの案内をAlexa Smart Properties対応のEcho Showで行うとともに、さらなる音声機能を強化することで、フロントへの入電率を48%から20%にまで低減させています(※2)。</p>

<h3><strong>Alexa Smart Propertiesをベースとしたサービス拡張へ、さらなる生成AI活用も視野に</strong></h3>

<p>今後、TradFitはAlexa Smart Propertiesを活用したサービスをさらに拡張していくとしています。</p>

<p>伊東氏は「今後は宿泊業界をはじめ、ヘルスケア業界、自治体などさまざまな企業・組織に向けて、Alexa Smart Propertiesを通じてTradFitがカスタマイズした付加価値の高いサービスを提供していきたいと考えています。この取り組みにより、日本のホスピタリティ業界の課題解決に貢献し、社会課題の解決に寄与していきます」と意欲を語ります。</p>

<img src="https://dhhmpfovkf2ub.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/tradfit/tradfit_002.JPG" alt="TradFit株式会社 代表取締役 戸田 良樹 氏" class="w-full h-auto rounded-lg my-6" />
<p class="text-sm text-gray-600">TradFit株式会社 代表取締役 戸田 良樹 氏<br>撮影場所:WeWork Marunouchi Kitaguchi</p>

<p>今後のビジネス拡大とともに、TradFitは誰もが健やかに過ごせる「ウェルビーイング」な社会の実現を掲げています。「国内に軸足を置きながら、宿泊業界、ヘルスケア業界、さらには自治体と多方面にわたってビジネスを展開し、少子高齢化や過疎化、独居など、多くの課題の解決に取り組んでいきます。また、課題先進国と呼ばれる日本社会が抱える問題は、現在の状況や将来的な視点で考えると、グローバルでも同じ問題が起こるのではないかと感じています。日本発のサービスは世界でも通用すると考えており、将来的には国外にもサービスを展開し、心身ともに豊かな暮らしを提供していきます」と戸田氏は意気込みを語ります。</p>

<h5><strong>SP様プロフィール</strong></h5>

<p>「世界中の人々に当社が提供するサービスを通じてより良い暮らしを提供する」ことをミッションに掲げ、音声AIソリューションを展開。近年では、Alexaの法人向けサービス「Alexa Smart Properties」をベースに、日本のホスピタリティ産業や自治体向けに独自技術を付加してローカライズしたサービス「Hospitalia(ホスピタリア)」を提供し、実績を重ねています。</p>

<p class="text-sm text-gray-600">※1 データ採取期間:2025年2月。Alexaの回答数のうち、電話に誘導した回答をカウントしフロントへの問い合わせ件数の削減効果を測定。</p>
<p class="text-sm text-gray-600">※2 入電率:1日あたりの宿泊組数÷フロント入電件数=入電率。今回は計測期間の入電率の期間平均を記載。<br>導入前計測期間:2023年12月3日~2023年12月17日。<br>導入後計測期間:2024年1月16日~2024年2月15日。</p>

<p class="text-sm text-gray-600 mt-4">*取材時期 2025年5月</p>
<p class="text-sm text-gray-600">*記載内容(役職、数値、固有名詞等)はすべて取材時の情報です。</p>

<p class="mt-6"><strong>■元記事リンク</strong><br><a href="https://developer.amazon.com/ja-JP/blogs/alexa/alexa-smart-properties/tradfit" target="_blank" rel="noreferrer noopener">https://developer.amazon.com/ja-JP/blogs/alexa/alexa-smart-properties/tradfit</a></p>

<p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>

<p><strong>■本件に関する報道関係者からのお問い合わせ</strong><br>E-mail:contact@tradfit.com</p>`
  },
    {
      date: '2025.07.28',
      category: '事例・リリース',
      title: 'トラベルボイスに弊社取得特許が掲載されました。TradFit社、あらゆるデータを統合・分析・生成する「スマートBIツール」で基本特許、サービス利用状況を可視化',
      content: `<p>TradFit社は、あらゆるデータを統合・分析・生成する「スマートBIツール」で基本特許を取得し、サービス利用状況を可視化することが可能になりました。</p>
  <p>この特許技術により、企業はデータドリブン経営を加速させ、より効率的な意思決定が可能になります。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.07.24',
      category: '事例・リリース',
      title: '世界初!あらゆるデータを統合し、サービス利用状況を可視化するビジネスインテリジェンスツール!データドリブン経営を加速する基本特許(ビジネスモデル特許)「スマートBIツール」を取得',
      content: `<p>TradFit株式会社は、世界初となるあらゆるデータを統合し、サービス利用状況を可視化するビジネスインテリジェンスツールの基本特許(ビジネスモデル特許)「スマートBIツール」を取得しました。</p>
  <p>この革新的な技術により、企業はデータドリブン経営を加速させ、より効率的な意思決定が可能になります。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.07.23',
      category: '事例・リリース',
      title: '世界の知財情報をわかりやすく解説するメディア IP Media +Vision【プラスヴィジョン】へ掲載されました',
      content: `<p>TradFit株式会社の取り組みが、世界の知財情報をわかりやすく解説するメディア「IP Media +Vision【プラスヴィジョン】」に掲載されました。</p>
  <p>当社の革新的な特許技術と、ホスピタリティ業界への貢献が評価されています。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.07.19',
      category: '事例・リリース',
      title: '世界初!宿泊予約中の方々が希望する場合に宿泊施設を自動で紹介!ビジネスモデル特許(基本特許技術)「移動先宿泊施設レコメンド3」を取得',
      content: `<p>TradFit株式会社は、世界初となる宿泊予約中の方々が希望する場合に宿泊施設を自動で紹介するビジネスモデル特許(基本特許技術)「移動先宿泊施設レコメンド3」を取得しました。</p>
  <p>この革新的な技術により、旅行者の次の目的地での宿泊施設選びがより簡単で便利になります。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.06.06',
      category: '事例・リリース',
      title: '群馬県初!ホテルサンダーソンへ日本パスコム社と業務提携先のTradFit社が提供する生成AI Hospitalia(Amazon ASP for Hospitality)を導入',
      content: `<p>群馬県初となる取り組みとして、ホテルサンダーソンへ日本パスコム社と業務提携先のTradFit社が提供する生成AI「Hospitalia(Amazon ASP for Hospitality)」を導入しました。</p>
  <p>この導入により、ホテルのサービス品質向上と業務効率化を実現します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.05.09',
      category: '事例・リリース',
      title: '生成AIスピーカー「ホスピタリア」導入事例に学ぶ、ホスピタリティ領域の事業者が人手不足の課題を解消する打ち手とは?',
      content: `<p>生成AIスピーカー「ホスピタリア」の導入事例を通じて、ホスピタリティ領域の事業者が直面する人手不足の課題を解消する具体的な方法をご紹介します。</p>
  <p>実際の導入施設での成果と、効果的な活用方法について詳しく解説しています。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.04.04',
      category: '事例・リリース',
      title: '生成AIスピーカー活用で宿泊施設はどう変わるのか、トラッドフィット「Hospitalia」導入施設に、顧客体験からバックヤードまで変化を聞いた',
      content: `<p>生成AIスピーカーの活用により、宿泊施設がどのように変化するのか。トラッドフィット「Hospitalia」を導入した施設に、顧客体験からバックヤードまでの変化について詳しくお聞きしました。</p>
  <p>実際の現場での効果と、今後の展望についてご紹介します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.27',
      category: '事例・リリース',
      title: 'AI音声サービスのTradFit社、スマートホーム導入支援会社と戦略的連携、AI、IoT技術で人手不足解消を推進',
      content: `<p>AI音声サービスを提供するTradFit社は、スマートホーム導入支援会社と戦略的連携を締結しました。</p>
  <p>AI、IoT技術を活用することで、業界全体の人手不足解消を推進していきます。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.27',
      category: '事例・リリース',
      title: 'TradFitは、ao.と包括的業務提携を発表!観光・宿泊・ヘルスケア・自治体等の各種助成金・補助金等の支援を共同推進!',
      content: `<p>TradFit株式会社は、ao.と包括的業務提携を締結したことを発表しました。</p>
  <p>観光・宿泊・ヘルスケア・自治体等の各種助成金・補助金等の支援を共同で推進し、業界全体の発展に貢献します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.26',
      category: '事例・リリース',
      title: 'TradFit × 三和テレム スマートホーム市場の革新へ!包括的業務提携を発表',
      content: `<p>TradFit株式会社と三和テレムは、スマートホーム市場の革新を目指し、包括的業務提携を締結したことを発表しました。</p>
  <p>両社の強みを活かし、より快適で便利なスマートホーム環境の実現を目指します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.21',
      category: '事例・リリース',
      title: 'AI音声サービスのTradFit社、民泊エアビーのパートナー制度に参画、登録施設の収益性改善を支援',
      content: `<p>AI音声サービスを提供するTradFit社は、民泊エアビーのパートナー制度に参画しました。</p>
  <p>登録施設の収益性改善を支援し、より質の高いサービス提供を実現します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.19',
      category: '事例・リリース',
      title: 'TradFit、Airbnb Partnersに参画 〜Airbnbと連携し、宿泊業界での生成AI活用などを促進〜',
      content: `<p>TradFit株式会社は、Airbnb Partnersに参画しました。</p>
  <p>Airbnbと連携し、宿泊業界での生成AI活用などを促進することで、業界全体のデジタル化を推進します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.02.17',
      category: '事例・リリース',
      title: '【スタートアップ企業特集】TradFit セキュアな音声データプラットフォームを構築',
      content: `<p>スタートアップ企業特集として、TradFit株式会社のセキュアな音声データプラットフォーム構築の取り組みが紹介されました。</p>
  <p>安全性と利便性を両立した革新的なプラットフォームについて詳しく解説しています。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.02.04',
      category: '事例・リリース',
      title: '京都の旅館が宿泊施設向け生成AIスピーカーを導入、トラッドフィット「Hospitalia」でできることとは?',
      content: `<p>京都の旅館が宿泊施設向け生成AIスピーカーを導入しました。</p>
  <p>トラッドフィット「Hospitalia」でできることについて、実際の導入事例を通じて詳しくご紹介します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.02.03',
      category: '事例・リリース',
      title: '法人・自治体向け「Amazon Alexa」は、課題ドリブンな日本社会に何をもたらすか',
      content: `<p>法人・自治体向け「Amazon Alexa」が、課題ドリブンな日本社会にもたらす変革について考察します。</p>
  <p>AI技術の活用により、様々な社会課題の解決が期待されています。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.11.05',
      category: '事例・リリース',
      title: 'AI音声サービスのTradFit社、施設の管理システムと利用サービスを連携、自動的にパーソナライズ応答する特許取得',
      content: `<p>AI音声サービスを提供するTradFit社は、施設の管理システムと利用サービスを連携し、自動的にパーソナライズ応答する特許を取得しました。</p>
  <p>この技術により、より個別化されたサービス提供が可能になります。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.11.01',
      category: '事例・リリース',
      title: '世界初!ホテル・旅館・病院・介護・不動産・オフィスビル等のあらゆる管理システムやユーザー利用サービス連携。自動的にパーソナライズ化されたサービス提供!ビジネスモデル特許「スマートシステム連携2」を取得',
      content: `<p>TradFit株式会社は、世界初となるホテル・旅館・病院・介護・不動産・オフィスビル等のあらゆる管理システムやユーザー利用サービスを連携し、自動的にパーソナライズ化されたサービスを提供するビジネスモデル特許「スマートシステム連携2」を取得しました。</p>
  <p>この技術により、宿泊業界全体のサービス品質向上が期待されます。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.10.09',
      category: '事例・リリース',
      title: 'AI音声サービスのTradFit社、宿泊客の個々のニーズに最適化した応答できる基本特許、宿泊管理システムとの連携で',
      content: `<p>AI音声サービスを提供するTradFit社は、宿泊客の個々のニーズに最適化した応答ができる基本特許を取得しました。</p>
  <p>宿泊管理システムとの連携により、よりパーソナライズされたサービス提供が可能になります。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.10.06',
      category: '事例・リリース',
      title: '世界初!ホテル・旅館・民泊・グランピング等の宿泊施設の基幹管理システム(PMS)や宿泊者利用サービスと連携。自動的にパーソナライズ化されたサービス提供!ビジネスモデル特許「スマートシステム連携」を取得',
      content: `<p>TradFit株式会社は、世界初となるホテル・旅館・民泊・グランピング等の宿泊施設の基幹管理システム(PMS)や宿泊者利用サービスと連携し、自動的にパーソナライズ化されたサービスを提供するビジネスモデル特許「スマートシステム連携」を取得しました。</p>
  <p>この技術により、宿泊業界全体のサービス品質向上が期待されます。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.09.10',
      category: '事例・リリース',
      title: '宿泊施設向けAIサービスTradFit社、音声リクエストにテキストで応答する特許取得、宿泊客、高齢者によりわかりやすく',
      content: `<p>宿泊施設向けAIサービスを提供するTradFit社は、音声リクエストにテキストで応答する特許を取得しました。</p>
  <p>宿泊客や高齢者により分かりやすいサービス提供を実現します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.09.10',
      category: '事例・リリース',
      title: '世界初!宿泊者からの音声リクエストに対して雑音環境下においても国内外の宿泊ゲスト・高齢者・患者の方々へ分かりやすく案内をする機能! 基本特許「スマートガイダンス」を取得',
      content: `<p>TradFit株式会社は、世界初となる宿泊者からの音声リクエストに対して雑音環境下においても国内外の宿泊ゲスト・高齢者・患者の方々へ分かりやすく案内をする機能の基本特許「スマートガイダンス」を取得しました。</p>
  <p>この技術により、より多くの方々に快適なサービスを提供できます。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.08.20',
      category: '事例・リリース',
      title: '宿泊施設が「音声×生成AI」でできること、おもてなし最前線で起きる変化と、その効果とは? -トラベルボイスLIVEレポート(PR)',
      content: `<p>宿泊施設が「音声×生成AI」でできることについて、おもてなし最前線で起きる変化と、その効果について詳しく解説します。</p>
  <p>トラベルボイスLIVEでのレポートをお届けします。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.07.17',
      category: '事例・リリース',
      title: '宿泊施設向けAIサービスTradFit社、テクノロジー活用で「ヘルスツーリズム」推進、韓国のIT投資企業と提携',
      content: `<p>宿泊施設向けAIサービスを提供するTradFit社は、テクノロジー活用で「ヘルスツーリズム」を推進するため、韓国のIT投資企業と提携しました。</p>
  <p>健康と観光を融合した新しい旅行体験の創出を目指します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.07.17',
      category: '事例・リリース',
      title: 'MILESEUMとTradFitは、次世代先端産業DX分野(AI、IoT、ロボティクス、生体認証ドアロック、デジタルサイネージ活用等での無人化・省人化)、ヘルスツーリズム等について包括的業務提携を締結',
      content: `<p>MILESEUMとTradFitは、次世代先端産業DX分野(AI、IoT、ロボティクス、生体認証ドアロック、デジタルサイネージ活用等での無人化・省人化)、ヘルスツーリズム等について包括的業務提携を締結しました。</p>
  <p>両社の技術とノウハウを結集し、業界の革新を推進します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.13',
      category: '事例・リリース',
      title: 'AIスピーカーTradFit社、メタバース空間創造プラットフォームで特許取得、誰でも本人確認だけで出店が可能に',
      content: `<p>AIスピーカーを提供するTradFit社は、メタバース空間創造プラットフォームで特許を取得しました。</p>
  <p>誰でも本人確認だけで出店が可能になる革新的なプラットフォームを実現します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.07',
      category: '事例・リリース',
      title: '宿泊施設向けAIスピーカーTradFit社、スマホから取得した情報で、移動先の最適なホテルを予約まで完了する新サービス',
      content: `<p>宿泊施設向けAIスピーカーを提供するTradFit社は、スマホから取得した情報で、移動先の最適なホテルを予約まで完了する新サービスを開始しました。</p>
  <p>旅行者の利便性を大幅に向上させる革新的なサービスです。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.06',
      category: '事例・リリース',
      title: '世界初!メタバース空間創造プラットフォーム!基本特許「スマートメタバース」を取得',
      content: `<p>TradFit株式会社は、世界初となるメタバース空間創造プラットフォームの基本特許「スマートメタバース」を取得しました。</p>
  <p>この革新的な技術により、新しいデジタル空間の創造が可能になります。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.01',
      category: '事例・リリース',
      title: '宿泊施設向けAIスピーカーTradFit社、宿泊客の要望を簡単に管理できるUIで特許取得、オペレーション改善を支援',
      content: `<p>宿泊施設向けAIスピーカーを提供するTradFit社は、宿泊客の要望を簡単に管理できるUIで特許を取得しました。</p>
  <p>オペレーション改善を支援し、施設運営の効率化を実現します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.31',
      category: '事例・リリース',
      title: '世界初!宿泊ゲストのスマホ等から取得した移動先の宿泊施設を自動で紹介!基本特許「移動先宿泊施設レコメンド2」を取得',
      content: `<p>TradFit株式会社は、世界初となる宿泊ゲストのスマホ等から取得した移動先の宿泊施設を自動で紹介する基本特許「移動先宿泊施設レコメンド2」を取得しました。</p>
  <p>旅行者の次の目的地での宿泊施設選びをサポートします。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.30',
      category: '事例・リリース',
      title: '宿泊施設向けAIスピーカーTradFit社、音声で宿泊客を個別識別できる新技術、特許を取得',
      content: `<p>宿泊施設向けAIスピーカーを提供するTradFit社は、音声で宿泊客を個別識別できる新技術の特許を取得しました。</p>
  <p>よりパーソナライズされたサービス提供が可能になります。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.30',
      category: '事例・リリース',
      title: '世界初!宿泊ゲストのリクエストを簡単な操作で見易く管理できる画期的なUI「スマートリクエスト管理UI」の特許を取得',
      content: `<p>TradFit株式会社は、世界初となる宿泊ゲストのリクエストを簡単な操作で見易く管理できる画期的なUI「スマートリクエスト管理UI」の特許を取得しました。</p>
  <p>施設スタッフの業務効率を大幅に向上させます。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.24',
      category: '事例・リリース',
      title: 'TradFit社、AIスピーカーでホテル客室温度を最適化する特許、日本に続きフィリピンでも取得',
      content: `<p>TradFit社は、AIスピーカーでホテル客室温度を最適化する特許を、日本に続きフィリピンでも取得しました。</p>
  <p>グローバルな展開を加速し、世界中の宿泊施設でのサービス提供を目指します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.24',
      category: '事例・リリース',
      title: '世界初!どの宿泊ゲストがリクエストしたかを自動で判定!基本特許「スマート話者判定」を取得',
      content: `<p>TradFit株式会社は、世界初となるどの宿泊ゲストがリクエストしたかを自動で判定する基本特許「スマート話者判定」を取得しました。</p>
  <p>より正確で効率的なサービス提供が可能になります。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.22',
      category: '事例・リリース',
      title: '世界初!自動で室内温度や照明等の客室環境を宿泊ゲストに最適な状態に!フィリピンでも基本特許「客室スマートコントロール」を取得',
      content: `<p>TradFit株式会社は、世界初となる自動で室内温度や照明等の客室環境を宿泊ゲストに最適な状態にする基本特許「客室スマートコントロール」を、フィリピンでも取得しました。</p>
  <p>国際的な特許取得により、グローバル展開を加速します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.11',
      category: '事例・リリース',
      title: '龍宮城スパホテル三日月、全室にAIスピーカー導入、生成AIの組み込みや、スマートルームの試験導入も',
      content: `<p>龍宮城スパホテル三日月は、全室にAIスピーカーを導入しました。</p>
  <p>生成AIの組み込みや、スマートルームの試験導入も行い、最先端のホテル体験を提供します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.05',
      category: '事例・リリース',
      title: '龍宮城スパホテル三日月の富士見亭・龍宮亭全室にAIスピーカーを導入',
      content: `<p>龍宮城スパホテル三日月の富士見亭・龍宮亭全室にAIスピーカーを導入しました。</p>
  <p>宿泊客により快適で便利な滞在体験を提供します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.04',
      category: '事例・リリース',
      title: '北海道初!TradFitは、東急ホテルズ&リゾーツの「札幌ストリームホテル」にAlexa Smart Properties for Hospitalityを導入',
      content: `<p>北海道初となる取り組みとして、TradFitは東急ホテルズ&リゾーツの「札幌ストリームホテル」にAlexa Smart Properties for Hospitalityを導入しました。</p>
  <p>北海道でのサービス展開を開始します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.04',
      category: '事例・リリース',
      title: '日本初・業界初!TradFit、ホテルなどのあらゆる宿泊施設に特化したAmazon「Alexa Smart Properties」のソリューションプロバイダーへ認定',
      content: `<p>日本初・業界初となる快挙として、TradFitはホテルなどのあらゆる宿泊施設に特化したAmazon「Alexa Smart Properties」のソリューションプロバイダーへ認定されました。</p>
  <p>この認定により、より高品質なサービス提供が可能になります。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.07.29',
      category: '事例・リリース',
      title: 'UXとIoTのクロスフィールドを極めたUXデザイナーの私市瑞希がCDOに就任',
      content: `<p>UXとIoTのクロスフィールドを極めたUXデザイナーの私市瑞希が、TradFit株式会社のCDO(Chief Design Officer)に就任しました。</p>
  <p>より優れたユーザー体験の提供を目指します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.05.06',
      category: '事例・リリース',
      title: '椎名茂氏がTradFitのアドバイザーに就任。経営戦略立案、グローバル進出戦略、AIを活用したDX戦略等を強化',
      content: `<p>椎名茂氏がTradFitのアドバイザーに就任しました。</p>
  <p>経営戦略立案、グローバル進出戦略、AIを活用したDX戦略等を強化し、さらなる成長を目指します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.04.17',
      category: '事例・リリース',
      title: '宿泊施設向けAIスピーカーTradFit社、「チャットGPT」活用の宿泊客応答サービスを開始、言語を自動判定し多言語で',
      content: `<p>宿泊施設向けAIスピーカーを提供するTradFit社は、「チャットGPT」を活用した宿泊客応答サービスを開始しました。</p>
  <p>言語を自動判定し、多言語での対応が可能になります。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.04.15',
      category: '事例・リリース',
      title: 'TradFitは、日本初の「ChatGPTの自動応答サービス」のβ版を提供',
      content: `<p>TradFit株式会社は、日本初となる「ChatGPTの自動応答サービス」のβ版の提供を開始しました。</p>
  <p>最先端のAI技術を活用した革新的なサービスです。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.03.06',
      category: 'メディア掲載事例・リリース',
      title: '宿泊施設向けAIスピーカーTradFit社、最高技術責任者にIto氏、アジア初のアマゾンAlexa Champion',
      content: `<p>宿泊施設向けAIスピーカーを提供するTradFit社は、最高技術責任者(CTO)にアジア初のアマゾンAlexa ChampionであるIto氏を迎えました。</p>
  <p>技術力のさらなる強化を図ります。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.02.21',
      category: '事例・リリース',
      title: '宿泊施設向けAIスピーカーTradFit社、客室環境を自動で最適化する技術、宿泊者の属性で制御モデルを選択',
      content: `<p>宿泊施設向けAIスピーカーを提供するTradFit社は、客室環境を自動で最適化する技術を開発しました。</p>
  <p>宿泊者の属性に応じて制御モデルを選択し、より快適な環境を提供します。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.02.16',
      category: '事例・リリース',
      title: 'TradFitは、新潟県の革新的なスタートアップ企業として「J-Startup NIIGATA」に認定',
      content: `<p>TradFit株式会社は、新潟県の革新的なスタートアップ企業として「J-Startup NIIGATA」に認定されました。</p>
  <p>地域経済の発展に貢献する企業として評価されています。</p>
  <p><strong>■本件に関する問い合わせ</strong><br>TradFit株式会社<br>E-mail:info@tradift.com</p>`
    }
  ]

};

export default ja;
